<template>
  <div>
    <div class="box-top" ref="box-top"></div>
    <div
      class="page-top animate__animated animate__fast fixed-top"
      ref="top"
      id="top"
    >
      <nav class="navbar navbar-expand-lg justify-content-md-center">
        <a class="navbar-brand" href="/">
          <img src="/img/logo.png" width="100" height="45" alt="" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="fales"
          aria-label="Toggle navigation"
          @click="handleExpanded"
        >
          <svg
            v-if="!expanded"
            class="bi bi-list-ul"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
            />
          </svg>
          <svg
            v-if="expanded"
            class="bi bi-x"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
            />
            <path
              fill-rule="evenodd"
              d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
            />
          </svg>
        </button>
        <div
          class="collapse navbar-collapse offset-xl-2 offset-lg-2 flex-grow-0"
          id="navbarNavAltMarkup"
        >
          <ul class="navbar-nav">
            <li class="nav-item active">
              <a class="nav-link selectedNav" href="/"> 首页 </a>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                关于我们
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="/AboutUs">公司简介</a>
                <!-- <a class="dropdown-item" href="/History">企业文化</a> -->
                <a class="dropdown-item" href="/Honor">荣誉资质</a>
                <a class="dropdown-item" href="/WorldDuty">企业社会责任</a>

                <!-- <a class="dropdown-item" href="/WorldDuty">社会责任 </a> -->
              </div>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                产品介绍
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="/Arhud">HUD</a>
                <!-- <a class="dropdown-item" href="/Whud">W-HUD</a> -->
                <a class="dropdown-item" href="/CoolingCabinet">车载冰箱 </a>
                <a class="dropdown-item" href="/peripheralProducts"
                  >其他智能座舱产品
                </a>
              </div>
            </li>
            <!-- <li class="nav-item">
            <a class="nav-link" href="#">产品服务</a>
          </li> -->
            <!-- <li class="nav-item">
              <a class="nav-link" href="/News">新闻中心</a>
            </li> -->
            <li class="nav-item">
              <a class="nav-link" href="/cooperation">合作伙伴</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/News">新闻中心</a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" href="/WorldDuty">企业社会责任</a>
            </li> -->
            <li class="nav-item">
              <a class="nav-link" href="/Contact">联系我们</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "XLtop",

  data() {
    return {
      expanded: false,
      lastScrollTop: undefined,
    };
  },
  methods: {
    init() {
      $(".nav-link").hover(function (e) {
        $(".nav-link")[0].classList.remove("selectedNav");
        let navlinkDome = $(".nav-link");
        for (const item of navlinkDome) {
          item.classList.remove("selectedNav");
        }
        let hoverDomObj = e.currentTarget;
        hoverDomObj.classList.add("selectedNav");
      });
      $(".nav-item").hover(
        function () {
          if ($(this).children("div").length > 0) {
            let dom = $(this).children("div")[0];
            console.log($(this).offsetWidth);
            var height = 0;
            for (const item of dom.children) {
              height += item.clientHeight;
            }
            dom.style.height = height + 20 + "px";
            dom.style.visibility = "visible";
          }
        },
        function () {
          if ($(this).children("div").length > 0) {
            let dom = $(this).children("div")[0];
            dom.style.height = "0";
            dom.style.visibility = "hidden";
          }
        }
      );
    },
    handleScrolltup() {
      this.$refs["top"].classList.add("d-block");
      this.$refs["top"].classList.remove("d-none");
      this.$refs["top"].classList.add("page-top-background");
      this.$refs["top"].classList.add("animate__fadeInDown");
      document.getElementsByClassName(
        "dropdown-menu"
      )[0].style.backgroundColor = "#2d3237";
      document.getElementsByClassName(
        "dropdown-menu"
      )[1].style.backgroundColor = "#2d3237";
      // this.$refs["top"].classList.remove("animate__fadeInUp");
    },
    handleScrolldown() {
      // this.$refs["top"].classList.add("d-none");
      // this.$refs["top"].classList.remove("d-block");
      // this.$refs["top"].classList.remove("page-top-background");
      // this.$refs["top"].classList.remove("animate__fadeInDown");
      // this.$refs["top"].classList.add("animate__fadeInUp");
    },
    handleExpanded() {
      this.expanded = !this.expanded;
    },
  },
  mounted() {
    this.init();
    let _this = this;
    // 监听浏览器的滚动事件 判断是向上滚动还是向下滚动
    // _this.lastScrollTop = this.$refs["top"].offsetHeight;
    let offsetHeight = this.$refs["top"].offsetHeight + 20;
    _this.lastScrollTop = offsetHeight;
    window.addEventListener("scroll", function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      console.log(scrollTop, _this.lastScrollTop);
      if (scrollTop > _this.lastScrollTop) {
        _this.handleScrolldown();
        _this.lastScrollTop = scrollTop;
      } else {
        _this.handleScrolltup();
        if (scrollTop > offsetHeight) {
          _this.lastScrollTop = scrollTop;
        } else {
          _this.handleScrolldown();
          _this.$refs["top"].classList.add("d-block");
        }
      }
      if (scrollTop === 0) {
        _this.$refs["top"].classList.remove("page-top-background");
        document.getElementsByClassName(
          "dropdown-menu"
        )[0].style.backgroundColor = "#2d323700";
        document.getElementsByClassName(
          "dropdown-menu"
        )[1].style.backgroundColor = "#2d323700";
      }
    });
  },
  beforeDestroy() {
    let _this = this;
    // 监听浏览器的滚动事件 判断是向上滚动还是向下滚动
    var lastScrollTop = 0;
    window.addEventListener("scroll", function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop) {
        _this.handleScrolldown();
      } else {
        if (scrollTop === 0) {
          _this.handleScrolldown();
        } else {
          _this.handleScrolltup();
        }
      }
      if (scrollTop === 0) {
        _this.$refs["top"].classList.remove("page-top-background");
      }
      lastScrollTop = scrollTop;
    });
  },
};
</script>

<style lang="less" scoped>
@import "../style/index.less";

.page-top {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  .navbar {
    z-index: 99;
    a {
      padding: 0;
    }
    .nav-link {
      margin: 1rem 2rem;
      font-size: 1.25rem;
    }
    @media (max-width: 960px) {
      .nav-link {
        font-size: 1.4rem;
        margin: 1rem 0;
      }
    }
    #navbarNavAltMarkup {
      .nav-item {
        margin: 0 1.2rem;
      }
    }
    @media (max-width: 1024px) {
      #navbarNavAltMarkup {
        .nav-item {
          margin: 0 0.2rem;
        }
      }
    }
    .dropdown-menu {
      display: block;
      top: 100%;
      left: 30px;
      background-color: #10111400;
      color: #fff !important;
      border: none;
      line-height: 30px;
      height: 0;
      overflow: hidden;
      transition: height 0.6s ease, visibility 0.6s ease;
      padding:0 6% 0;
      .dropdown-item {
        color: rgba(255, 255, 255, 0.8) !important;
        position: relative;
        font-size: 1rem;
      }
      @media (max-width: 960px) {
        .dropdown-item {
          font-size: 1.4rem;
        }
      }
      .dropdown-item:hover {
        color: #fff !important;
        background-color: #fff0;
      }
      .dropdown-item:focus {
        background-color: #fff0;
      }
      .dropdown-item:after {
        content: "";
        display: block;
        width: 0;
        height: 2px;
        position: absolute;
        left: 0;
        bottom: -4px;
        background: #fff;
        transition: all 0.3s ease-in-out;
      }
      .dropdown-item:hover::after {
        width: 80%;
      }
      @media (max-width: 1200px) {
        .dropdown-item:hover:after {
          display: none;
        }
      }
    }
    @media (max-width: 1200px) {
      .dropdown-menu {
        padding: 0;
      }
    }
  }
}
</style>
